import { render, staticRenderFns } from "./LocationMappingList.vue?vue&type=template&id=353d01e2&"
import script from "./LocationMappingList.vue?vue&type=script&lang=js&"
export * from "./LocationMappingList.vue?vue&type=script&lang=js&"
import style0 from "./LocationMappingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports